<template>
  <div :class="'nav nav-' + direction">
    <a aria-label="Previous page">
      <div class="arrow-wrapper">
        <div class="arrow-bg">
          <div class="arrow"></div>
        </div>
      </div>
    </a>
  </div>
</template>

<script>
  export default {
    name: 'CarouselNavigation',

    props: {
      direction: {
        default: 'next',
        type: String
      }
    }
  }
</script>

<style lang="scss" scoped>

  .nav {
    @apply absolute z-10;
    width: 72px;
    transform: translateY(-50%);
    top: 50%;

    :focus {
      @apply outline-none;
    }

    .arrow-wrapper {
      width: 47px;
      @apply bg-white relative;
      padding: 2px;
    }

    .arrow-bg {
      @apply flex items-center bg-grey-3 justify-center cursor-pointer;
      width: 45px;
      height: 38px;
      border-radius: 0 50px 50px 0;
      transition: background-color .25s ease;

      &:hover {
        @apply bg-grey-2;
      }

      .arrow {
        @apply border-2 border-solid border-white border-t-0 border-l-0 mr-0 ml-4;
        width: 15px;
        height: 15px;
      }
    }

    &.nav-next {
      right: -24px;

      .arrow-wrapper {
        border-radius: 50px 0 0 50px;
      }

      .arrow-bg {
        transform: rotate(180deg);
        margin-right: -2px;
      }

      .arrow {
        transform: rotate(135deg);
      }
    }

    &.nav-prev {
      @apply pin-l;

      .arrow-wrapper {
        border-radius: 0 50px 50px 0;
      }

      .arrow-bg {
        margin-left: -2px;
      }

      .arrow {
        transform: rotate(135deg);
      }
    }
  }
</style>
